exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animatestart[data-v-02710469]{opacity:1;transform:translateX(0)}.hidden[data-v-02710469]{display:none;opacity:0}.pagination[data-v-02710469]{list-style-type:none}.pagination-item[data-v-02710469]{display:inline-block}.active[data-v-02710469]{background-color:#4aae9b;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02710469","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/carousel/simple-carousel.vue
// module id = 1039
// module chunks = 0